export type ToneType =
  | 'primary'
  | 'secondary'
  | 'success'
  | 'destructive'
  | 'warning'
  | 'accent'
  | 'info'
  | 'neutral';

export type LegacyToneType =
  | 'primary'
  | 'secondary'
  | 'success'
  | 'danger'
  | 'warning'
  | 'accent'
  | 'info'
  | 'neutral';

export type VariantType = 'solid' | 'subtle' | 'outline' | 'ghost' | 'link';

export type SizeType = 'small' | 'medium' | 'large';

export type EssenceType = 'light' | 'dark';

export type IconPositionType = 'start' | 'end';

export const resolveLegacyTone = (tone: ToneType | undefined, color: LegacyToneType): ToneType => {
  if (tone) {
    return tone;
  }

  return color === 'danger' ? 'destructive' : color;
};
